<template>
	<div :class="cssWrapper">
		<span
			class="productcard__first--event"
			v-for="(sticker, code) in list"
			:class="code"
			:title="sticker"
			v-html="sticker"
		></span>
	</div>
</template>

<script>
	export default {
		name: "CitrusProductStickers",
		props: {
			cssWrapper: {
				type: [Boolean, String],
				default: () => 'productcard__first--params'
			},
			list: {
				type: [Boolean, Object, Array],
				default: () => false
			}
		}
	}
</script>